import { render, staticRenderFns } from "./GasReadings.vue?vue&type=template&id=612517b7&scoped=true&"
import script from "./GasReadings.vue?vue&type=script&lang=js&"
export * from "./GasReadings.vue?vue&type=script&lang=js&"
import style0 from "./GasReadings.vue?vue&type=style&index=0&id=612517b7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612517b7",
  null
  
)

component.options.__file = "GasReadings.vue"
export default component.exports